import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faBooks } from '@fortawesome/pro-light-svg-icons';
import { faBriefcase, faLandmark, faMedal, faBooks as faBooksRegular } from '@fortawesome/pro-regular-svg-icons';

/*
 * Icon definitions are imported rather than named by string. V2 only registers the
 * icons in icons.json — the set generated from jss_sections.icon — so a name-addressed
 * lookup here would silently render nothing. Direct imports also tree-shake.
 *
 * Typed IconProp rather than IconDefinition: each pro-* package ships its own nested
 * copy of fontawesome-common-types, so IconDefinition is a different type identity
 * depending on which package the icon came from.
 */

export const features = [
  { id: 1, label: 'Lowest Price Guarantee:', description: 'We beat any publisher quote.' },
  { id: 2, label: 'Single Invoice Billing:', description: 'Stop tracking 50 different receipts.' },
  { id: 3, label: 'Dedicated Support:', description: 'Real account managers, not bots.' },
  { id: 4, label: 'Net-30 Terms:', description: 'Purchase Orders (POs) accepted.' },
];

/**
 * These include federal references (State Department, Veterans Affairs). That's fine
 * unconditionally: this page only ever renders on the US site, so there is no other
 * market that would see them.
 */
export const trustSignals: { id: number; icon: IconProp; label: string }[] = [
  { id: 1, icon: faLandmark as IconProp, label: 'U.S. State Department' },
  { id: 2, icon: faMedal as IconProp, label: 'U.S. Dept. of Veterans Affairs' },
  { id: 3, icon: faBooksRegular as IconProp, label: 'Thousands of Libraries' },
  { id: 4, icon: faBriefcase as IconProp, label: 'Thousands of Businesses' },
];

/** The hero's mobile-only masthead icon. */
export const heroIcon = faBooks;
